import { render, staticRenderFns } from "./c-pagination.vue?vue&type=template&id=f138eb98&scoped=true&"
import script from "./c-pagination.vue?vue&type=script&lang=js&"
export * from "./c-pagination.vue?vue&type=script&lang=js&"
import style0 from "./c-pagination.vue?vue&type=style&index=0&id=f138eb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138eb98",
  null
  
)

export default component.exports